
import ShaderService from "../../../lib/services/shader/shader_service";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";
import SceneObject from "../../../lib/services/scene/sceneobject";
import Mushroom from "./mushroom";
import { MushroomType } from "./mushroom";
import CollisionService from "../../../lib/services/collision/collision_service";
import Stage from "../../../lib/services/stage/stage";

export default class MushroomPatch extends SceneObject 
{

  private debug_mush:Mushroom  | null = null;
   

  constructor(key: string) 
  {
     super(key);
    
     this.build_patch();

     //this.make_debug_short_mushroom();
     //this.make_debug_medium_mushroom();
     //this.make_debug_tall_mushroom();
     
 }

  make_debug_short_mushroom()
  {
      const y = this.get_y(MushroomType.short);
      const scale = this.get_scale(MushroomType.short)
     this.debug_mush = this.make_short_mushroom("debugsh");
     this.debug_mush.transform.set_position(-2,y,5);
     this.debug_mush.transform.set_rotation(0, 0, 0);
     this.debug_mush.transform.set_scale(scale, scale, scale);
     this.debug_mush.transform.update_matrix();
     this.add_child(this.debug_mush);
  }

  make_debug_medium_mushroom()
  {
      const y = this.get_y(MushroomType.medium);
      const scale = this.get_scale(MushroomType.medium)
     this.debug_mush = this.make_medium_mushroom("debugsh");
     this.debug_mush.transform.set_position(-2,y,5);
     this.debug_mush.transform.set_rotation(0, 0, 0);
     this.debug_mush.transform.set_scale(scale, scale, scale);
     this.debug_mush.transform.update_matrix();
     this.add_child(this.debug_mush);
  }

  make_debug_tall_mushroom()
  {
      const y = this.get_y(MushroomType.tall);
      const scale = this.get_scale(MushroomType.tall)
     this.debug_mush = this.make_tall_mushroom("debugsh");
     this.debug_mush.transform.set_position(-2,y,5);
     this.debug_mush.transform.set_rotation(0, 0, 0);
     this.debug_mush.transform.set_scale(scale, scale, scale);
     this.debug_mush.transform.update_matrix();
     this.add_child(this.debug_mush);
  }

  make_short_mushroom(key:string):Mushroom
  {
    return new Mushroom(key,"mushroom_short",1,1,MushroomType.short);
  }

  make_medium_mushroom(key:string):Mushroom
  {
    return new Mushroom(key,"mushroom_medium",1,1.5,MushroomType.medium);
  }

  make_tall_mushroom(key:string):Mushroom
  {
    return new Mushroom(key,"mushroom_tall",1,1.5,MushroomType.tall);
  }

  get_y(mush_type:number):number
  {
     if(mush_type == MushroomType.short)
     {
            return -0.05;
     }
     else if(mush_type == MushroomType.medium)
     {
            return -0.08348999917507172;
     }

     //MushroomType.tall
     return -0.05;

  }

  get_scale(mush_type:number):number
  {
    if(mush_type == MushroomType.short)
     {
            return 0.5;
     }
     else if(mush_type == MushroomType.medium)
     {
            return 0.5;
     }

     //MushroomType.tall
     return 0.6957014203071594;
  }


  build_patch()
  {
            // SHORT mushrooms — height ~0.31, cap around y = 0.36
        const SHORT_POSITIONS: Float32Array[] = [
        new Float32Array([-4.2, 0, -3.6]),  // NW stairway start
        new Float32Array([-3.6, 0, -3.0]),
        new Float32Array([ 3.4, 0,  3.4]),  // SE stairway end
        new Float32Array([ 4.0, 0,  4.0]),
        new Float32Array([-1.8, 0,  0.8]),  // center descending pair (E end)
        new Float32Array([ 1.6, 0, -2.4]),  // mid-N descending pair
        new Float32Array([ -0.4, 0,  3.4]),  // SW arc tail
        new Float32Array([-3.6, 0,  4.0]),  // SW arc end
        ];

        // MEDIUM mushrooms — height ~0.54, cap around y = 0.62
        const MEDIUM_POSITIONS: Float32Array[] = [
        new Float32Array([-3.0, 0, -2.4]),  // NW stairway middle
        new Float32Array([-2.4, 0, -1.8]),  // NW stairway middle ascent
        new Float32Array([ 2.6, 0,  2.6]),  // SE stairway middle descent
        new Float32Array([ 1.8, 0,  1.8]),  // SE stairway middle
        new Float32Array([-0.6, 0,  0.2]),  // center descending pair
        new Float32Array([ 0.8, 0, -1.6]),  // mid-N descending pair
        new Float32Array([-1.6, 0,  3.2]),  // SW arc middle
        new Float32Array([-2.6, 0,  3.6]),  // SW arc descent
        ];

        // TALL mushrooms — height ~0.79, cap around y = 0.88
        const TALL_POSITIONS: Float32Array[] = [
        new Float32Array([-1.8, 0, -1.2]),  // NW stairway peak
        new Float32Array([ 1.0, 0,  1.0]),  // SE stairway peak
        new Float32Array([ 0.0, 0, -0.6]),  // center stairway peak (mid-N descending)
        ];

         const shscale = this.get_scale(MushroomType.short);
         const shy = this.get_y(MushroomType.short);

        for(var i= 0; i< SHORT_POSITIONS.length; i++)
        {
            const key= "mush_sh"+i;
            let m = this.make_short_mushroom(key);
             m.transform.set_position(SHORT_POSITIONS[i][0],shy,SHORT_POSITIONS[i][2]);
             m.transform.set_rotation(0, 0, 0);
             m.transform.set_scale(shscale, shscale, shscale);
             m.transform.update_matrix();
             this.add_child(m);
        }

        const mdscale = this.get_scale(MushroomType.medium);
        const mdy = this.get_y(MushroomType.medium);

        for(var i= 0; i< MEDIUM_POSITIONS.length; i++)
        {
            const key= "mush_md"+i;
            let m = this.make_medium_mushroom(key);
             m.transform.set_position(MEDIUM_POSITIONS[i][0],mdy,MEDIUM_POSITIONS[i][2]);
             m.transform.set_rotation(0, 0, 0);
             m.transform.set_scale(mdscale, mdscale, mdscale);
             m.transform.update_matrix();
             this.add_child(m);
        }

        const tlscale = this.get_scale(MushroomType.tall);
        const tly = this.get_y(MushroomType.tall);

        for(var i= 0; i< TALL_POSITIONS.length; i++)
        {
            const key= "mush_tl"+i;
            let m = this.make_tall_mushroom(key);
             m.transform.set_position(TALL_POSITIONS[i][0],tly,TALL_POSITIONS[i][2]);
             m.transform.set_rotation(0, 0, 0);
             m.transform.set_scale(tlscale, tlscale, tlscale);
             m.transform.update_matrix();
             this.add_child(m);
        }

  }



  async build(device: GPUDevice, format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {
        super.build(device,format,shader_service,resource_service);

        const collision_service = Stage.instance().collision_service;
        collision_service.jump_graph.build(
             this.children, // make children public on SceneObject or expose getter
             collision_service
         );
  }

  tick(delta_time: number): void 
  {
     super.tick(delta_time);

     if(this.debug_mush)
     {
         this.debug_mush.volume_placement.tick(delta_time,0);
     }

  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
     super.prepare(device,camera);
  }

  draw(pass: GPURenderPassEncoder): void 
  {
     super.draw(pass);
  }
}